// @flow

import {Direction} from '../constants';
import type {DirectionType} from '../constants';

const getStyleValue = styleValue => Math.round(parseFloat(styleValue));

type ArgumentsType = {|
    contentSize: number,
    node: HTMLDivElement,
    offsetSize: string,
    direction: DirectionType,
|};

export const getContainerSize = ({contentSize, node, offsetSize, direction}: ArgumentsType): number => {
    let maxSize;
    let border;
    let padding;
    let containerSize;
    const parent = node.parentNode;
    const computedStyle = window.getComputedStyle(parent);

    if (direction === Direction.VERTICAL) {
        maxSize = getStyleValue(computedStyle.maxHeight);
        border = getStyleValue(computedStyle.borderTopWidth) + getStyleValue(computedStyle.borderBottomWidth);
        padding = getStyleValue(computedStyle.paddingTop) + getStyleValue(computedStyle.paddingBottom);
    } else {
        maxSize = getStyleValue(computedStyle.maxWidth);
        border = getStyleValue(computedStyle.borderLeftWidth) + getStyleValue(computedStyle.borderRightWidth);
        padding = getStyleValue(computedStyle.paddingLeft) + getStyleValue(computedStyle.paddingRight);
    }

    if (maxSize) {
        border = border ? border : 0;
        padding = padding ? padding : 0;
        containerSize = maxSize - border - padding;
    } else {
        // $FlowFixMe TODO: an indexer property is missing in HTMLDivElement
        const parentSize = parent[offsetSize];
        // $FlowIgnoreMe WHY: scrollable always has parentNode
        containerSize = parent.childNodes.length === 1 ?
            parentSize :
            Array.prototype.reduce.call(parent.childNodes, (otherChildrenHeight, child) => {
                return child !== node ? otherChildrenHeight - child[offsetSize] : otherChildrenHeight;
            }, parentSize);
        containerSize = containerSize + 1 === contentSize ? contentSize : containerSize;
    }

    return containerSize;
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../constants");
